module.exports = __webpack_public_path__ + "img/HelpingHand-02.240041fc.svg";